export const causeList = [
  {
    class: 'cancer-cause',
    imgSrc: 'assets/images/causes-v3/medical.png',
    title: 'Medical',
    desc: 'Fund critical care',
    link: '/cause/medical-fundraising',
    outer: false
  },
  {
    class: 'acci-cause',
    imgSrc: 'assets/images/causes-v3/memorial.png',
    title: 'Memorial',
    desc: 'Honour loved ones',
    link: '/cause/memorial-fundraising',
    outer: false
  },
  {
    class: 'liver-cause',
    imgSrc: 'assets/images/causes-v3/children.png',
    title: 'Children',
    desc: 'Empower young lives',
    link: '/cause/help-children-v3',
    outer: false
  },
  {
    class: 'heart-cause',
    imgSrc: 'assets/images/causes-v3/education.png',
    title: 'Education',
    desc: 'Support learning',
    link: '/cause/fundraising-for-education',
    outer: false
  },
  {
    class: 'animal-cause',
    imgSrc: 'assets/images/causes-v3/animal.png',
    title: 'Animal',
    desc: 'Protect and care',
    link: '/cause/animal-fundraising',
    outer: false
  },
  {
    class: 'other-cause',
    imgSrc: 'assets/images/causes-v3/others.png',
    title: 'Others',
    desc: 'Support urgent causes',
    link: '/crowdfunding/fundraisers',
    outer: false
  }
];
